'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/yearBefore.js
// module id = 225
// module chunks = 0